import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'searchHosts',
})
export class SearchHostsPipe implements PipeTransform {
  transform(
    value: any[],
    search: string
  ): any[] {
    if (value && value.length) {
      const regexp = new RegExp(search, 'i');
      const properties = Object.keys(value[0]);
      return [
        ...value.filter((item) => {
          return properties.some((property) => regexp.test(item[property]));
        }),
      ];
    }else{
      return []
    }
  }
}